<template>
  <div class="message">
    <div
      v-if="comment?.text"
      ref="text"
      class="description"
      :class="{ slice: isViewMoreComp }"
    >
      {{ comment.text }}
      <div
        v-if="isViewMoreComp"
        class="more"
        @click="useShowMore"
      >
        Ещё
      </div>
    </div>
    <GuideMessageInfo
      :comment="comment"
      @guide-click="(id) => emit('guideClick', id)"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, computed, useTemplateRef } from 'vue';

  import { type GuidesComments } from '@/shared/api/generated/api';
  import GuideMessageInfo from '@/shared/ui/GuideMessageInfo.vue';

  const textRef = useTemplateRef('text');

  defineProps<{
    comment: GuidesComments;
  }>();

  const emit = defineEmits(['guideClick']);

  const isViewMore = ref<boolean>(false);

  const lengthHeight: number = 24;
  const column: number = 4;

  const showMore = computed<boolean>(() => {
    if (!textRef.value?.offsetHeight) {
      return false;
    }

    return textRef.value.offsetHeight > lengthHeight * column;
  });

  const isViewMoreComp = computed<boolean>(() => {
    return showMore.value && !isViewMore.value;
  });

  const useShowMore = (): void => {
    isViewMore.value = true;
  };
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;

  .message {
    gap: var(--alias-space-16);
    padding: var(--alias-space-12);
    background: var(--alias-color-background-subtle);
    border-radius: var(--alias-radius-16, 16px);
  }

  .description {
    &:hover {
      .more {
        color: var(--alias-color-link-default-hovered);
        text-decoration-color: var(--alias-color-link-default-hovered);
      }
    }

    @include legacy-typography.base-400-400-regular;
  }

  .more {
    position: absolute;
    right: 0;
    bottom: 0;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-color: var(--alias-color-text-subtler);
    text-decoration-skip-ink: none;
    cursor: pointer;
    background-color: var(--alias-color-background-subtle);

    &::before {
      position: absolute;
      top: 0;
      left: -8px;
      width: 8px;
      height: 100%;
      content: '';
      background-color: var(--alias-color-background-subtle);
    }

    @include legacy-typography.base-400-400-regular;
  }

  .slice {
    position: relative;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
</style>
